var map = {
	"./Alpha.png": 828,
	"./Beta.png": 829,
	"./Chi.png": 830,
	"./Delta.png": 831,
	"./Epsilon.png": 832,
	"./Eta.png": 833,
	"./Gamma.png": 834,
	"./Iota.png": 835,
	"./Kappa.png": 836,
	"./Lambda.png": 837,
	"./Mu.png": 838,
	"./Nu.png": 839,
	"./Omega.png": 840,
	"./Omicron.png": 841,
	"./Phi.png": 842,
	"./Pi.png": 843,
	"./Psi.png": 844,
	"./Rho.png": 845,
	"./Sigma.png": 846,
	"./Tau.png": 847,
	"./Theta.png": 848,
	"./Upsilon.png": 849,
	"./Xi.png": 850,
	"./Zeta.png": 851
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1326;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x ^\.\/.*\.png$
// module id = 1326
// module chunks = 0